import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
interface MapWidgetProps {
  address: string;
}
// Helper component to invalidate map size when container changes
const MapResizer = () => {
  const map = useMap();
  useEffect(() => {
    const handleResize = () => {
      map.invalidateSize();
    };
    // Initial resize
    setTimeout(handleResize, 300);
    // Add resize listener
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [map]);
  return null;
};
export const MapWidget: React.FC<MapWidgetProps> = ({
  address
}) => {
  const [position] = useState([40.7128, -74.006]); // Default to NYC
  return <div className="h-[120px] rounded-lg overflow-hidden relative z-0" data-id="element-61">
      <div className="relative w-full h-full" data-id="element-62">
        <MapContainer center={position} zoom={14} className="w-full h-full" zoomControl={false} scrollWheelZoom={false} dragging={false} data-id="element-63">
          <MapResizer data-id="element-64" />
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' data-id="element-65" />
          <Marker position={position} data-id="element-66" />
          <div className="absolute bottom-0 left-0 right-0 bg-background/90 backdrop-blur-sm p-2 text-xs" data-id="element-67">
            {address || 'Enter an address to see location'}
          </div>
        </MapContainer>
      </div>
    </div>;
};